import { collections } from "@/mocks/home";

export default function Collections() {
  return (
    <section id="collections" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1180px] px-4 md:px-6">
        <div className="flex flex-col gap-3 border-b border-background-300 pb-6 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-[0.2em] text-primary-700">
              04 / COLLECTIONS
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-[32px]">
              编辑合集，成组取用更快
            </h2>
          </div>
          <p className="max-w-md text-sm leading-6 text-foreground-600">
            合集是编辑按主题二次整编的清单，比起逐个浏览分区，更适合想一次性拿到成组资源的场景。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {collections.map((item) => (
            <article
              key={item.title}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-300 bg-background-50 transition hover:border-primary-300"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} · 91下载合集`}
                  className="h-full w-full object-cover object-top transition duration-700 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-foreground-950/75 px-3 py-1 text-[11px] text-background-50">
                  {item.edition}
                </span>
                <span className="absolute bottom-3 right-3 rounded-full bg-accent-500 px-3 py-1 text-[11px] font-medium text-foreground-950">
                  {item.count}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">
                  {item.subtitle}
                </p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-700">
                  打开合集
                  <i className="ri-arrow-right-line transition group-hover:translate-x-0.5" />
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}